import http from '@/utils/http'
import Cookie from 'js-cookie'

const accept = ({ token, password, passwordConfirmation, platformToken }) => http()
  .put('/invitations', {
    invitation_token: token,
    password: password,
    password_confirmation: passwordConfirmation,
    resource_type: 'Admin',
    scope: 'admin'
  }, {
    headers: {
      PlatformToken: platformToken
    }
  })
  .then(token => {
    Cookie.set('authorization', token.data)
    return token
  })

export default {
  accept
}



// WEBPACK FOOTER //
// ./src/api/invitation.js